<div class="drawer" *ngIf="displayedState" [class.hide-caret]="hideCaret">
    <div #caret class="drawer-caret" [style.left]="caretPosition"></div>
    <div class="drawer-content" #content>
        <ng-content></ng-content>
    </div>
</div>
